import View from '../app/View';

// Modules
import MediaHero from '../../components/pages-components/media-hero';
import '../../components/article-components/article';
import '../../components/article-components/article-paragraph';
import '../../components/article-components/article-image';
import '../../components/article-components/article-custom-html';
import '../../components/article-components/article-2-column-image-copy';
import '../../components/article-components/article-external-sources';
import ArticleSuggestedProducts from '../../components/article-components/article-suggested-products';
import ProductCard from '../../components/product-card/product-card';

const pageView = new View();
pageView.init({
  // Add template specific components here
  MediaHero,
  ArticleSuggestedProducts,
  ProductCard,
});
